import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useScrollToHash() {
    const { hash } = useLocation();

    useEffect(() => {
        if (!hash) return;

        const id = hash.replace("#", "");

        const scroll = () => {
            const element = document.getElementById(id);
            if (element) {
                const yOffset = -80;
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        };
        setTimeout(scroll, 100);
    }, [hash]);
}